import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import BrandKitPage from "@/pages/BrandKitPage";
import { I18nProvider } from "@/i18n/I18nContext";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/brand-partnership-kit" element={<BrandKitPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "rgba(10,18,14,0.85)",
              color: "var(--tt-text)",
              border: "1px solid var(--tt-border-strong)",
              backdropFilter: "blur(16px)",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </I18nProvider>
    </div>
  );
}

export default App;
